import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import ProfessionalExperience from './components/ProfessionalExperience';
import Qualifications from './components/Qualifications';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CommandPalette from './components/CommandPalette';
import ResumeModal from './components/ResumeModal';
import ScrollProgressBar from './components/ScrollProgressBar';
import { FaArrowUp } from 'react-icons/fa';
import { initGA, trackPageView, trackEvent } from './utils/analytics';
import './App.css';

function App() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [isCommandPaletteOpen, setIsCommandPaletteOpen] = useState(false);
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);

  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname, document.title);

    const handleScroll = () => setShowTopBtn(window.scrollY > 400);
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setIsCommandPaletteOpen((prev) => {
          const nextState = !prev;
          if (nextState) trackEvent('command_palette_open', { trigger: 'keyboard_shortcut' });
          return nextState;
        });
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const openResume = (trigger = 'cta') => {
    trackEvent('resume_view', { trigger });
    setIsResumeModalOpen(true);
  };
  const openCmd = () => {
    trackEvent('command_palette_open', { trigger: 'navbar_icon' });
    setIsCommandPaletteOpen(true);
  };

  return (
    <div className="portfolio-app">
      <ScrollProgressBar />
      <Navbar onOpenCommandPalette={openCmd} onOpenResume={openResume} />
      <main>
        <Hero onOpenResume={openResume} />
        <About />
        <Projects />
        <ProfessionalExperience />
        <Skills />
        <Qualifications />
        <Contact />
      </main>
      <Footer onOpenResume={openResume} />

      <CommandPalette
        isOpen={isCommandPaletteOpen}
        onClose={() => setIsCommandPaletteOpen(false)}
        onOpenResume={() => {
          setIsCommandPaletteOpen(false);
          openResume();
        }}
      />

      <ResumeModal
        isOpen={isResumeModalOpen}
        onClose={() => setIsResumeModalOpen(false)}
      />

      {showTopBtn && (
        <button
          className="back-to-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll back to top"
        >
          <FaArrowUp />
        </button>
      )}
    </div>
  );
}

export default App;